(() => {
  const root = document.getElementById('SeulabKbPopup');
  if (!root || root.dataset.ready === '1') return;
  root.dataset.ready = '1';

  const products = [
    {problem:'Dökülme eğilimli saç derisi',result:'Daha güçlü, canlı saç',name:'Hair Loss Control Shampoo Aroma Herb',img:'https://cdn.shopify.com/s/files/1/0748/2671/1196/files/hair-loss-control-shampoo-sac-dokulme-karsiti-sampuan-500ml-191.jpg?v=1788944376',url:'https://www.seulab.co/products/nard-hair-loss-control-shampoo-aroma-herb'},
    {problem:'Yıpranmış, hasarlı saç',result:'Pürüzsüz, ipeksi saç',name:'Damage RX Treatment',img:'https://cdn.shopify.com/s/files/1/0748/2671/1196/files/damage-rx-treatment-hasar-onarici-sac-kremi-500ml-224.jpg?v=1788944702',url:'https://www.seulab.co/products/damage-rx-treatment-hasar-onarici-sac-kremi-500ml'},
    {problem:'Tıkalı, yağlı gözenekler',result:'Temiz ve dengeli cilt',name:'Low pH Pore Deep Cleansing Foam',img:'https://cdn.shopify.com/s/files/1/0748/2671/1196/files/low-ph-pore-deep-cleansing-foam-dusuk-ph-li-gozenekleri-arindiran-yuz-temizleme-kopugu-436.jpg?v=1788974044',url:'https://www.seulab.co/products/low-ph-pore-deep-cleansing-foam-40ml-dusuk-ph-gozenekleri-arindiran-yuz-temizleme-kopugu-40-ml'},
    {problem:'Mat, yorgun cilt',result:'Dolgun, canlı görünüm',name:'Collagen Peptide Vitalizing Mask',img:'https://cdn.shopify.com/s/files/1/0748/2671/1196/files/collagen-peptide-vitalizing-mask-kolajen-peptit-canlandirici-yuz-maskesi-5-li-249.jpg?v=1788959636',url:'https://www.seulab.co/products/nard-collagen-peptide-vitalizing-mask-nard-kolajen-peptit-canlandirici-maske'},
    {problem:'Susuz, gergin cilt',result:'Nemli, ferah cilt',name:'Hyaluronic Acid Aqua Mask',img:'https://cdn.shopify.com/s/files/1/0748/2671/1196/files/hyaluronic-acid-aqua-mask-pack-hyaluronik-asit-nemlendirici-yuz-maskesi-5-li-252.jpg?v=1788945124',url:'https://www.seulab.co/products/nard-hyaluronic-acid-aqua-mask-nard-hyaluronik-asit-nemlendirici-aqua-maske'},
    {problem:'Akne eğilimli, hassas cilt',result:'Sakin, dengeli cilt',name:'ACNE Cream',img:'https://cdn.shopify.com/s/files/1/0748/2671/1196/files/acne-cream-50ml-akne-karsiti-bariyer-onarici-cilt-bakim-kremi-457.jpg?v=1788960209',url:'https://www.seulab.co/products/acne-cream-akne-karsiti-cilt-bakim-kremi-50-ml'}
  ];

  const $ = s => root.querySelector(s);
  const overlay=$('[data-kb-overlay]'), close=$('[data-kb-close]'), machine=$('[data-kb-machine]'), lever=$('[data-kb-lever]');
  const gate=$('[data-kb-gate]'), form=$('[data-kb-form]'), email=$('[data-kb-email]'), spinBtn=$('[data-kb-spin]');
  const problem=$('[data-kb-problem]'), solution=$('[data-kb-solution]'), productImg=$('[data-kb-product]'), result=$('[data-kb-result]');
  const ticket=$('[data-kb-ticket]'), ticketImg=$('[data-kb-ticket-img]'), ticketName=$('[data-kb-ticket-name]'), cta=$('[data-kb-cta]');
  let subscribed=false, spinning=false, current=-1, oldOverflow='';

  const popupSessionKey='seulabKbPopupShown';
  const hasShownThisSession=()=>{
    try{return sessionStorage.getItem(popupSessionKey)==='1'}catch(_){return false}
  };
  const markShownThisSession=()=>{
    try{sessionStorage.setItem(popupSessionKey,'1')}catch(_){}
  };

  const open=()=>{
    if(hasShownThisSession())return;
    markShownThisSession();
    root.hidden=false;
    requestAnimationFrame(()=>root.classList.add('is-open'));
    root.setAttribute('aria-hidden','false');
    oldOverflow=document.body.style.overflow;
    document.body.style.overflow='hidden';
  };
  const shut=()=>{root.classList.remove('is-open');root.setAttribute('aria-hidden','true');document.body.style.overflow=oldOverflow;setTimeout(()=>{if(!root.classList.contains('is-open'))root.hidden=true},360)};
  if(!hasShownThisSession())setTimeout(open,15000);
  close.addEventListener('click',shut);
  overlay.addEventListener('click',e=>{if(e.target===overlay)shut()});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&root.classList.contains('is-open'))shut()});

  form.addEventListener('submit',e=>{
    e.preventDefault();
    const value=email.value.trim();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)){email.focus();email.style.borderColor='#a04358';return}
    subscribed=true;machine.classList.remove('is-locked');gate.hidden=true;spinBtn.style.display='block';
    try{fetch(form.action,{method:'POST',body:new FormData(form)}).catch(()=>{})}catch(_){}
  });

  const renderFinal=i=>{
    const p=products[i];problem.textContent=p.problem;result.textContent=p.result;solution.hidden=true;
    productImg.onerror=()=>{productImg.style.display='none';solution.textContent=p.name;solution.hidden=false};
    productImg.src=p.img;productImg.alt=p.name;productImg.style.display='block';
    ticketImg.src=p.img;ticketImg.alt=p.name;ticketName.textContent=p.name;cta.href=p.url;ticket.classList.add('is-shown');
  };

  const spin=()=>{
    if(!subscribed||spinning)return;spinning=true;root.classList.add('is-spinning');lever.classList.add('is-pulled');
    setTimeout(()=>lever.classList.remove('is-pulled'),260);
    let ticks=0;
    const timer=setInterval(()=>{
      const r=Math.floor(Math.random()*products.length);problem.textContent=products[r].problem;
      if(++ticks>=10){clearInterval(timer);let f;do{f=Math.floor(Math.random()*products.length)}while(f===current&&products.length>1);current=f;renderFinal(f);root.classList.remove('is-spinning');spinning=false}
    },85);
  };
  lever.addEventListener('click',spin);spinBtn.addEventListener('click',spin);
})();